import request from '../utils/request';
import { GET_HRMS_SYNC_INTEGRATION, TERMINATE_HRMS_SYNC_CONNECTION } from '../routes/api';

class HrmsSyncApi {
  static get_hrms_sync_integration(options, onSuccess, onError) {
    return request({ url: GET_HRMS_SYNC_INTEGRATION, ...options }, onSuccess, onError);
  }

  static terminateConnection(options, onSuccess, onError) {
    return request({ url: TERMINATE_HRMS_SYNC_CONNECTION, ...options }, onSuccess, onError);
  }
}

export default HrmsSyncApi;
